/**
 * Created by user on 2020/6/1.
 */

import tableCn2TwDebug from './data/table_cn2tw.debug';
import tableTw2CnDebug from './data/table_tw2cn.debug';

export * from './types';
import { IStaticDebugJSON, ITable } from './types';

export {
	tableCn2TwDebug,
	tableTw2CnDebug,
}

export default {
	tableCn2TwDebug,
	tableTw2CnDebug,
}
